<template>
	<div class="m-doc-content">
		<c-title>单据详情</c-title>
		<div>
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'docContent'
	}
</script>

<style lang="stylus" scoped>
	.m-doc-content {
		padding: 10px 24px 20px;

		>>> .c-field {
			padding: 5px 0;

			&-label {
				color: #999;
			}
		}
	}
</style>
